import { useState, useEffect, useRef } from "react";

export const HeroSlider = ({ slides = [], interval = 6000 }) => {
  const [i, setI] = useState(0);
  const n = slides.length;
  const paused = useRef(false);

  useEffect(() => {
    if (n <= 1) return undefined;
    const t = setInterval(() => { if (!paused.current) setI((p) => (p + 1) % n); }, interval);
    return () => clearInterval(t);
  }, [n, interval]);

  if (n === 0) return null;

  return (
    <section
      data-testid="shop-hero-slider"
      className="relative w-full overflow-hidden bg-black border-b border-white/10"
      onMouseEnter={() => { paused.current = true; }}
      onMouseLeave={() => { paused.current = false; }}
    >
      <div className="flex transition-transform duration-700 ease-out" style={{ transform: `translateX(-${i * 100}%)` }}>
        {slides.map((s, idx) => {
          const img = (
            <img
              src={s.src}
              alt={s.alt || ""}
              loading={idx === 0 ? "eager" : "lazy"}
              fetchpriority={idx === 0 ? "high" : "auto"}
              draggable={false}
              className="w-full h-auto block select-none"
            />
          );
          return (
            <div key={idx} data-testid={`hero-slide-${idx}`} className="min-w-full">
              {s.href ? <a href={s.href} aria-label={s.alt}>{img}</a> : img}
            </div>
          );
        })}
      </div>

      {n > 1 && (
        <div className="absolute bottom-3 sm:bottom-5 left-1/2 -translate-x-1/2 flex items-center gap-2">
          {slides.map((_, idx) => (
            <button
              key={idx}
              type="button"
              data-testid={`hero-dot-${idx}`}
              aria-label={`Przejdź do slajdu ${idx + 1}`}
              onClick={() => setI(idx)}
              className={`h-2 rounded-full transition-all ${i === idx ? "w-7 bg-amber-400" : "w-2 bg-white/50 hover:bg-white/80"}`}
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default HeroSlider;
